import React from 'react';
import { Badge } from './ui/badge';

const VerifiedBadge = ({ size = 'default', showText = false }) => {
  const sizeClasses = {
    small: 'w-4 h-4',
    default: 'w-5 h-5',
    large: 'w-6 h-6'
  };

  // Using the exact green verified badge provided
  const VerifiedIcon = ({ className }) => (
    <img
      src="https://customer-assets.emergentagent.com/job_halal-matrimony/artifacts/pk3tthki_bb637789-bee8-4150-9e45-573f936ede97.jpg"
      alt="Verified"
      className={`${className} inline-block object-contain`}
      title="Verified Profile"
    />
  );

  if (!showText) {
    return (
      <VerifiedIcon 
        className={`${sizeClasses[size]} flex-shrink-0`}
      />
    );
  }

  return (
    <Badge className="bg-green-600 hover:bg-green-700 flex items-center gap-1.5">
      <VerifiedIcon className="w-4 h-4" />
      <span>Verified</span>
    </Badge>
  );
};

export default VerifiedBadge;
